import Layout from '@/components/Layout/Vanilla';
import Hero from '@/components/Hero';
import AnchorNav from '@/components/AnchorNav';
import IndustryList from '@/components/IndustryList';
import Section from '@/components/Section';
import { fetchPage, gql } from '@/lib/graphcms';

export default function Customers({ page, industries }) {
  return (
    <Layout seo={page}>
      <Section>
        <Hero {...page} />

        <AnchorNav items={industries} />
        <IndustryList entries={industries} {...page} />
      </Section>
    </Layout>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { page, industries } =
    (await fetchPage(
      gql`
        query customeresPageQuery {
          page: page(where: { slug: "customers" }) {
            ...pageData # Fragment is inside the method
          }
          industries {
            id
            slug
            title
            subTitle
            content
            featuredContent
            featured
            caseStudies(where: { featured: true }) {
              externalUrl
              slug
              title
              coverImage {
                width
                height
                url(
                  transformation: {
                    image: { resize: { width: 960, fit: clip } }
                  }
                )
                alt
              }
              customer {
                name
                title
                twitterHandle
                bio
                photo {
                  url(
                    transformation: {
                      image: { resize: { width: 300, fit: clip } }
                    }
                  )
                  width
                  height
                  alt
                }
              }
              company {
                name
                url
                logo {
                  url(
                    transformation: {
                      image: { resize: { width: 300, fit: clip } }
                    }
                  )
                  width
                  height
                  alt
                }
              }
            }
          }
        }
      `,
      {
        preview,
      },
    )) || [];

  return {
    props: {
      preview,
      page,
      industries,
    },
    revalidate: 3600,
  };
};
